<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>
      <div class="query">
        <div class="query">
          <el-form ref="form" :inline="true" :model="form">
		    <el-form-item label="">
              <el-date-picker
				v-model="form.endDate"
				type="month"
				placeholder="选择月份">
				</el-date-picker>
            </el-form-item>  
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
              <el-button type="primary" size="small" @click="searchFun"
                >导出</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="w"
            label="月份"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="e"
            label="课程总数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="r"
            label="课时总数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="t"
            label="参与教师数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="y"
            label="教师薪酬"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
// import store from '@/store';
export default {
  //   components: {
  //     Detail: () => import("./details.vue"),
  //   },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        extOrgName: "",
        courseName: "",
        startDate: "",
        endDate: "",
        selectData: "",
      },
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 2,
      },

      info: "", // 出库单页面参数
     	tableData: [ 
		    {w:'2月',e:'2',r:'220',t:'6	',y:'￥6,800.00 '},
		    {w:'1月',e:'2',r:'189',t:'6	',y:'￥7,500.00 '},
		 ],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {},
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    console.log("获取学年学期数据--", this.semesterList);
    // this.getDataList();
  },
  methods: {
    async getDataList() {
      if (this.form.selectData == "" || this.form.selectData == null) {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        teacherId: "", 
        courseName: this.form.courseName,
        extOrgName: this.form.extOrgName,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      console.log("获取考勤列表数据---", data);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
    //   console.log(scope);
    //   this.detail.info = scope.row;
    //   this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  /* width: 170px; */
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
